import { Box, LinearProgress, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Document, Font, PDFViewer, Page, View } from '@react-pdf/renderer';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as ROUTES from '../../../router/Routes';
import FontWeightOpenSans from '../../../static/fonts/Open_Sans/static/OpenSans-Bold.ttf';
import FontOpenSans from '../../../static/fonts/Open_Sans/static/OpenSans-Regular.ttf';
import Modal from '../../../widgets/modals/Modal';
import ContainerTemplate from '../../../widgets/template/Container';
import { stylesDocPdf } from '../../pdfs';
import {
  asistenciasByHorarios,
  notasByBloquesPedagogicos,
} from './BoletinesHelper';
import FooterPdf from './pdf/FooterBoletinesPdf';
import HeaderPdf from './pdf/HeaderBoletinesPdf';
import NotasDefinitivasPdf from './pdf/NotasDefinitivasPdf';

Font.register({
  family: 'OpenSans',
  fonts: [{ src: FontOpenSans }, { src: FontWeightOpenSans, fontWeight: 700 }],
});

// Create Document Component
const BoletinesPdf = () => {
  const boletinesStore = Redux.useSelector((state) => state.boletines);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const seccionesStore = Redux.useSelector((state) => state.secciones);
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const horariosStore = Redux.useSelector((state) => state.horarios);

  const [boletines, setBoletines] = React.useState([]);
  const [loadingDoc, setLoadingDoc] = React.useState(true);

  React.useEffect(() => {
    boletinesStore.activo
      ? estudiante(boletinesStore.activo)
      : todosEstudiantes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const todosEstudiantes = () => {
    setBoletines([]);
    boletinesStore.all.forEach((boletin) => {
      estudiante(boletin);
    });
  };

  function estudiante(boletin) {
    const msteriasArray = notasByBloquesPedagogicos(
      bloquesPedagogicosStore.all,
      planEvaluacionStore.all,
      boletin.notasEvaluativas,
      boletin.actividadesExtras,
    );
    const estadisticas = asistenciasByHorarios(
      bloquesPedagogicosStore.all,
      planEvaluacionStore.all,
      horariosStore.all,
      boletin.asistenciasDiarias,
    );

    setBoletines((old) => [
      ...old,
      {
        estudiante: boletin.usuario,
        materias: msteriasArray,
        asistencias: estadisticas,
      },
    ]);
  }

  const doc = (
    <Document
      title={
        boletinesStore.activo
          ? `${boletinesStore.activo.usuario.perfil.dni} ${boletinesStore.activo.usuario.perfil.pnombre} ${boletinesStore.activo.usuario.perfil.papellido}`
          : `${seccionesStore.activo.nivelAcademico.nivelAcademico.nombre} SECCION ${seccionesStore.activo.nombre}`
      }
      onRender={({ blob }) => setLoadingDoc(false)}
    >
      <Page size="A4" style={stylesDocPdf.page}>
        {boletines.map((el) => {
          return (
            <View style={stylesDocPdf.body}>
              <View style={stylesDocPdf.section}>
                <HeaderPdf
                  entidades={entidadesStore}
                  seccion={seccionesStore.activo}
                  estudiante={el.estudiante}
                />
                <NotasDefinitivasPdf
                  bloques={bloquesPedagogicosStore.all}
                  estudiante={el}
                />
                <FooterPdf />
              </View>
            </View>
          );
        })}
      </Page>
    </Document>
  );

  return (
    <ContainerTemplate
      active={ROUTES.boletinesPdf}
      routes={[ROUTES.controlEstudios, ROUTES.boletines]}
    >
      <Grid container spacing={1}>
        <Grid item md={12}>
          <PDFViewer
            style={{
              width: '100%',
              height: '80vh',
              zIndex: 50,
            }}
            showToolbar={true}
          >
            {doc}
          </PDFViewer>
        </Grid>
        <Modal open={loadingDoc}>
          <Box sx={{ width: '100%' }}>
            <Typography variant="h6" sx={{ textAlign: 'center' }}>
              Generando {boletinesStore.activo ? 'boletín' : 'boletines'}...
            </Typography>
            <LinearProgress />
            {boletinesStore.activo ? null : (
              <>
                <Typography sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                  Cantidad de boletines procesando {boletines.length}
                </Typography>
                <Typography sx={{ textAlign: 'center' }}>
                  Este proceso puede que tarde entre 5 a 10 minutos para
                  completa, por favor espere.
                </Typography>
              </>
            )}
          </Box>
        </Modal>
      </Grid>
    </ContainerTemplate>
  );
};

export default BoletinesPdf;
